import { useQuery } from "@origin-digital/query";
import type { CategoryArticleItem } from "../../../services/categories/types";
import { fetchCategoryArticles } from "../../../services/categories";
import {
  toError,
  useShouldThrowQueryError,
} from "../../../hooks/useShouldThrowQueryError";

export interface UseSubcategoryArticlesOptions {
  enabled: boolean;
}

export interface UseSubcategoryArticlesResult {
  articles: CategoryArticleItem[];
  loading: boolean;
  error: Error | null;
}

export const useSubcategoryArticles = (
  id: number | undefined,
  { enabled }: UseSubcategoryArticlesOptions
): UseSubcategoryArticlesResult => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["support-subcategory-articles", id],
    queryFn: () => fetchCategoryArticles(String(id)),
    staleTime: 0,
    enabled: Boolean(id) && enabled,
  });

  const subcategoryArticlesError = toError(error);
  useShouldThrowQueryError(subcategoryArticlesError, {
    component: "CategoryPage",
    action: "fetchSubcategoryArticles",
  });

  return {
    articles: data?.articles ?? [],
    loading: isLoading && enabled,
    error: subcategoryArticlesError,
  };
};
